import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as successApiCall from '../../../../actionCreators/success';
import ProductsList from '../../../components/Success/ProductsList';

const productsDetail = {
  result: {},
};

function ProductDetail(props) {
  const { successApiCall, orderDetails, dataLocale, isExchangeFlow, cartData } = props;
  const refClicked = data => {
    successApiCall.activeFrameData(data, data.id);
  };
  if (isExchangeFlow) productsDetail.result = cartData;
  else
    productsDetail.result =
      orderDetails &&
      orderDetails.result &&
      orderDetails.result.orders &&
      orderDetails.result.orders[0];
  return (
    <div className="margin-t40">
      {orderDetails && (
        <ProductsList
          activeProductData={
            productsDetail &&
            productsDetail.result &&
            productsDetail.result.items &&
            productsDetail.result.items[0]
          }
          dataLocale={dataLocale}
          productsDetail={productsDetail}
          refClicked={refClicked}
        />
      )}
    </div>
  );
}

const mapStateToProps = state => {
  return {
    dataLocale: state.locale,
    orderDetails: state.order.orderDetails,
    activeFrameData: state.success.activeFrameData,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    successApiCall: bindActionCreators(successApiCall, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetail);
